export default "__VITE_ASSET__C6i8iXPy__"